import http from "./httpService";

export function createreply(commentbody, id) {
  return http.post(`${process.env.REACT_APP_API}/reply/create/${id}`, {
    comment: commentbody.comment,
  });
}
